<template>
  <div class="background">
    <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
      <div style="margin: 10px 0 20px 20px">
        <el-col :span="3" style="margin-left: 20px; margin-top: 10px">
          购票订单列表
        </el-col>
        <el-col :span="9" style="margin-top: 10px">
          状态
          <el-radio v-model="radio" label="1">全部</el-radio>
          <el-radio v-model="radio" label="2">已支付</el-radio>
          <el-radio v-model="radio" label="3">待支付</el-radio>
          <el-radio v-model="radio" label="4">已过期</el-radio>
        </el-col>
        <el-col :span="11">
          <div class="icon-container">
            <el-col :span="18" style="margin-top: 10px">
              <el-col :span="8" class="style1">
                <el-input
                    placeholder="订单号"
                    prefix-icon="el-icon-search"
                    v-model="searchId"
                    size="small"
                    @keydown.enter="search"
                    @blur="search"
                    @clear="refresh"
                    clearable
                >
                </el-input>
              </el-col>
              <el-col :span="10" style="margin-left: 10px;">
                <div class="icon-container">
                  <!--                                    <i class="el-icon-discover" @click="buyTicketList">筛选</i>-->
                  <!--                                    <i class="el-icon-date">日期</i>-->
                    <el-date-picker
                        style="width:68px;height: 29px "
                        v-model="value1"
                        type="date"
                        placeholder="">
                    </el-date-picker>
                  <i class="el-icon-s-promotion">导出</i>
                </div>
              </el-col>
            </el-col>
          </div>
        </el-col>
      </div>
      <div class="table_container">
        <el-table
            :data="tableData"
            style="width: 100%">
          <el-table-column
              type="index"
              label="序号"
              width="50">
          </el-table-column>
          <!--                    <el-table-column-->
          <!--                        label="用户ID"-->
          <!--                        prop="id"-->
          <!--                    >-->
          <!--                    </el-table-column>-->
          <el-table-column
              label="内容名称"
              prop="title"
              width="160"
          >
          </el-table-column>
          <el-table-column
              label="价格"
              prop="price">
          </el-table-column>
          <el-table-column
              label="票种"
              prop="ticketType">
          </el-table-column>
          <el-table-column
              label="订单号"
              prop="orderId"
              width="160"
          >
          </el-table-column>
          <el-table-column
              label="实付款"
              prop="payFee"
              width="70"
          >
          </el-table-column>
          <el-table-column
              label="数量"
              prop="ticketNum"
              width="70"
          >
          </el-table-column>
          <el-table-column
              label="状态"
              prop="status"
              width="100"
          >
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <i class="el-icon-edit">设置</i>
              <i class="el-icon-view">查看</i>
              <!--                            <el-button type="primary" size="mini" icon="el-icon-edit">设置</el-button>-->
              <!--                            <el-button type="primary" size="mini" icon="el-icon-view">查看</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination" style="text-align: left;margin-top: 10px;">
          <el-pagination
              class="pagination-wrapper"
              @size-change=handleSizeChange
              @current-change=buyTicketList
              :current-page=parseInt(pagination.page)
              :page-sizes=pagination.pageSizeOption
              :page-size=parseInt(pagination.size)
              layout="total, sizes, prev, pager, next"
              :total="pagination.total"
          >
          </el-pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import headTop from '../components/headTop'
import {baseUrl, baseImgPath} from '@/config/env'
import $ from 'jquery'

export default {
  data() {
    return {
      baseUrl,
      baseImgPath,
      city: {},
      offset: 0,
      limit: 20,
      count: 0,
      tableData: [],
      pagination: {
        page: 1,
        size: 20,
        total_pages: 1,
        total: 1,
        pageSizeOption: [20, 50, 100, 200]
      },
      selectTable: {},
      dialogFormVisible: false,
      categoryOptions: [],
      selectedCategory: [],
      address: {},
      radio: '1',
      searchId: '',
    }
  },
  created() {
    this.buyTicketList(0);
    console.log(11111)
  },
  components: {
    headTop,
  },
  methods: {
    search(currentPage) {
      if (currentPage === 0) {
        currentPage = this.pagination.page
      }
      console.log(this.searchId)
      if (!this.searchId) {
        this.buyTicketList(0)
      } else {
        this.buyTicketList(0)
      }
    },

    refresh() {
      this.searchId = '';
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pagination.size = pageSize
      this.getReservationOrder(0)
      console.log(`每页 ${pageSize} 条`);
    },
    buyTicketList(currentPage) {
      if (currentPage === 0 || currentPage == '[object PointerEvent]') {
        currentPage = this.pagination.page
      }
      var size = this.pagination.size
      if (size == undefined) {
        size = 20
      }
      console.log(`每33 ${currentPage} `);
      $.ajax({
        // url: 'https://dreamportal.nextscene.cn/api/orders/info',
        url: this.$settings.BASE_URL + `pay_order/info?page=${currentPage}&size=${size}&order_id=${this.searchId}`,
        type: 'POST',
        dataType: 'json',
            xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('获取到的数据：', res)
          let tableData = []
          if (res.info == 'ok') {
            if (!this.searchId) {
              res.orders.forEach(function (order) {
                if (order[1]) {
                  if (order[1]) {
                    // if (order[1].pending_payment == 0) {
                    //     var status = '取消付款'
                    // } else
                    if (order[1].ticketChecked) {
                      var status = '已核验'
                    } else if (order[1].selectSesstion && !rder[1].ticketChecked) {
                      var status = '已预约'
                    } else {
                      var status = '已付款'
                    }
                    var ticketTypeData = {
                      id: order[0].slice(0, 4),
                      title: order[1].title,
                      category: '地球档案',
                      price: order[1].price,
                      ticketType: '早鸟票',
                      orderId: order[0],
                      payFee: order[1].payFee,
                      ticketNum: order[1].ticketNum,
                      status: status
                    }
                    tableData.push(ticketTypeData)
                  }
                }
              })
            } else {
              if (res.info == 'ok' && res.orders && res.orders.order_info) {
                if (res.orders.order_info.ticketChecked) {
                  var status = '已核验'
                } else if (res.orders.order_info.selectSesstion && !res.orders.order_info.ticketChecked) {
                  var status = '已预约'
                } else {
                  var status = '已付款'
                }
                var ticketTypeData = {
                  id: this.searchId.slice(0, 4),
                  title: res.orders.order_info.title,
                  category: '地球档案',
                  price: res.orders.order_info.price,
                  ticketType: '早鸟票',
                  orderId: this.searchId,
                  payFee: res.orders.order_info.payFee,
                  ticketNum: res.orders.order_info.ticketNum,
                  status: status
                }
                tableData.push(ticketTypeData)
              } else if (res.info == 'ok' && res.orders == null) {
                this.$message({
                  message: '没有对应的订单ID',
                  type: 'error',
                  onClose: () => {
                    // 跳转到登录页
                    // this.$router.push('/')
                  }
                })
              } else if (res.info == 'error') {
                this.$message({
                  message: '没有对应的订单ID',
                  type: 'error',
                  onClose: () => {
                    // 跳转到登录页
                    // this.$router.push('/')
                  }
                })
              }
            }

            this.tableData = tableData
            this.pagination.page = res.pagination.page
            this.pagination.size = res.pagination.size
            this.pagination.total = res.pagination.total
            this.pagination.total_pages = res.pagination.total / res.pagination.size
            console.log('tableData', tableData)
          }
        },
        error: (error) => {
          console.log('请求失败：', error)
          this.$message({
            message: '请求有误，请联系管理员',
            type: 'error',
            onClose: () => {
              // 跳转到登录页
              // this.$router.push('/')
            }
          })
        }
      })
    },

  },
}
</script>

<style lang="less">
@import '../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.table_container {
  padding: 20px;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.background {
  background-color: #F4F5FA;
}

.icon-container {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: flex-end;
  gap: 10px; /* 设置图标之间的间距 */
}

/* 每个图标的样式 */
.icon-container i {
  display: flex; /* 让每个 i 标签成为 Flexbox 项 */
  align-items: center; /* 垂直居中文本 */
  justify-content: center; /* 水平居中文本 */
  border-radius: 4px; /* 可选：设置圆角 */
  /*border: 1px solid #5C16F2; !* 可选：设置边框 *!*/
  color: #5C16F2; /* 设置字体颜色 */
  font-size: 14px; /* 设置字体大小 */
  text-align: center; /* 确保文本水平居中 */
}

.el-icon-discover {
  width: 68px;
  height: 29px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #5C16F2;
  color: #5C16F2;
  font-size: 14px;
}

//.el-icon-date {
//  width: 68px;
//  height: 29px;
//  border-radius: 4px 4px 4px 4px;
//  border: 1px solid #5C16F2;
//  color: #5C16F2;
//  font-size: 14px;
//}
.el-icon-date{
  width: 68px !important;
  height: 29px !important;
  //border-radius: 4px 4px 4px 4px;
  //border: 1px solid #5C16F2;
  //color: #5C16F2;
  //font-size: 14px;
}
.el-input__inner{
    border: 0px solid #DCDFE6 !important;
}
.el-icon-s-promotion {
  width: 68px;
  height: 29px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #5C16F2;
  color: #5C16F2;
  font-size: 14px;
}

.style1 {
  width: Hug (68px) px;
  height: Fixed (29px) px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #5C16F2;
  text-align: center;
  justify-items: center;
  justify-content: center;
  margin: 0 10px 0 10px;
}

.icon-container {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: flex-end;
  gap: 10px; /* 设置图标之间的间距 */
}

/* 每个图标的样式 */
.icon-container i {
  display: flex; /* 让每个 i 标签成为 Flexbox 项 */
  align-items: center; /* 垂直居中文本 */
  justify-content: center; /* 水平居中文本 */
  border-radius: 4px; /* 可选：设置圆角 */
  /*border: 1px solid #5C16F2; !* 可选：设置边框 *!*/
  color: #5C16F2; /* 设置字体颜色 */
  font-size: 14px; /* 设置字体大小 */
  text-align: center; /* 确保文本水平居中 */
}

.el-icon-edit {
  /*width: 15px;*/
  /*height: 15px;*/
  /*background: #D6D0FF;*/
  /*border-radius: 10px;*/
  color: #5C16F2;

}

//.el-icon-view {
//  color: #5C16F2;
//}
</style>
